// Login.jsx - Staff sign in. Deliberately plain: one card, two fields, and no
// hint about whether an email exists.

import { Seo } from "../lib/seo.jsx";
import { useForm } from "../lib/hooks.js";
import { Button, Input, Alert, Panel } from "../ui/kit.jsx";
import { Shield } from "../ui/icons.jsx";

export default function Login({ onSignIn }) {
  const form = useForm({ email: "", password: "" });
  const submit = form.submit((values) => onSignIn(values));

  return (
    <div className="app-shell flex items-center justify-center px-5 py-12 safe-top safe-bottom">
      <Seo title="Sign in" path="/admin" noIndex />

      <div className="w-full max-w-sm">
        <p className="display text-[17px] tracking-[0.02em] text-ink text-center">
          International <span className="text-bronze">Gold</span> &amp; Silver
        </p>
        <p className="eyebrow text-center mt-2">Staff dashboard</p>

        <Panel className="p-7 mt-8">
          <form onSubmit={submit} noValidate className="space-y-4">
            <Input
              label="Email"
              type="email"
              autoComplete="username"
              autoFocus
              required
              {...form.field("email")}
            />
            <Input
              label="Password"
              type="password"
              autoComplete="current-password"
              required
              {...form.field("password")}
            />

            {form.message && <Alert tone="error">{form.message.text}</Alert>}

            <Button type="submit" loading={form.busy} className="w-full" size="lg">
              {form.busy ? "Signing in" : "Sign in"}
            </Button>
          </form>
        </Panel>

        <p className="hint text-center mt-6 flex items-center justify-center gap-2">
          <Shield size={14} className="text-bronze" />
          Accounts are created by an owner. There is no self sign up.
        </p>
      </div>
    </div>
  );
}
